import { Route, Routes } from "react-router-dom";
import { About } from "./component/home/about/about.component";
import { AngularCourse } from "./component/home/courses/angular/angular.component";
import Courses from "./component/home/courses/courses.component";
import { ReactCourse } from "./component/home/courses/reactcourse/reactcourse";
import Home from "./component/home/home.component";
import { WhyUs } from "./component/home/whyus/why-us.component";
import { YoutubeLinks } from "./component/home/youtube-links/youtube-links.component";
import { ContactTeam } from "./component/home/contact/contact.component";

export function AppRouting() {
    return (
        <Routes>
            <Route path="/" element={<Home></Home>}></Route>
            <Route path="/home" element={<Home></Home>}></Route>
            <Route path="/about" element={<>
                <About></About>
                <WhyUs></WhyUs>
            </>}></Route>
            <Route path="/courses" element={<Courses></Courses>}></Route>
            <Route path="/blog" 
                element={<>
                    <WhyUs></WhyUs>
                    <YoutubeLinks></YoutubeLinks>
                </>}></Route>
            <Route path="/contact" element={
                <ContactTeam></ContactTeam>
            }></Route>
            <Route path="/courses/angular" element={<AngularCourse></AngularCourse>}></Route>
            <Route path="/courses/react" element={<ReactCourse></ReactCourse>}></Route>
        </Routes>
    );
}
